import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useUpdateDestinationDialogValidationSchema = () => {
  const { t } = useTranslation(['validation']);

  return z
    .object({
      name: z
        .string()
        .min(1, t('required'))
        .max(
          255,
          t('maxCharacters', {
            count: 255,
          }),
        )
        .regex(/^[\p{L}\p{N} &-]+$/u, t('invalidFormat')),

      floor: z
        .string()
        .min(1, t('required'))
        .max(
          255,
          t('maxCharacters', {
            count: 255,
          }),
        )
        .regex(/^[\p{L}\p{N}\p{So}\p{Sk}\s.,!?()_*-]+$/u, t('invalidFormat')),

      description: z
        .string()
        .max(
          1024,
          t('maxCharacters', {
            count: 1024,
          }),
        )
        .optional(),

      maxCapacity: z.coerce
        .number({
          invalid_type_error: t('required'),
        })
        .min(
          0,
          t('minNumber', {
            number: 0,
          }),
        )
        .max(
          10000,
          t('maxNumber', {
            number: 10000,
          }),
        )
        .optional(),

      accessBeforeVisitInMinutes: z.coerce
        .number({
          invalid_type_error: t('required'),
        })
        .min(
          0,
          t('minNumber', {
            number: 0,
          }),
        )
        .max(
          10080,
          t('maxNumber', {
            number: 10080,
          }),
        )
        .optional(),

      accessAfterVisitInMinutes: z.coerce
        .number({
          invalid_type_error: t('required'),
        })
        .min(
          0,
          t('minNumber', {
            number: 0,
          }),
        )
        .max(
          10080,
          t('maxNumber', {
            number: 10080,
          }),
        )
        .optional(),
    })
    .strict();
};
